import React, { Component, Fragment } from "react"
import Pagination from "react-js-pagination"
import { connect } from "react-redux"

import getRights from "../../redux/action/rights"
import { bindActionCreators } from "redux"

//Component
import Field from "../../components/Common/Field/Field"
import AlertContainer from "react-alert"
import "./printFabric.css"
import Async from "react-select"
import {
  DevelopmentServices,
  UtilityService,
  StyleServices
} from "../../services"
import Pageheader from "../../components/Page/PageHeader/PageHeader"
import Loading from "../../components/Common/Loading"
import TableRowSelect from "../../components/PrintFabricNo/TableRowSelect"
import PrintFabricPage from "../../components/PrintFabricPage"
import PrintStylePage from "../../components/PrintStylePage"

//Assets
import download from "../../assets/images/download.png"
import printer from "../../assets/images/printer.png"

//options
import { tableHeader } from "../../services/common/options"

class PrintFabricNumber extends Component {
  state = {
    moduleName: "",
    activePage: 1,
    totalItemsCount: 0,

    NumberFrom: "",
    NumberTo: "",
    SearchDateFrom: "",
    SearchDateTo: "",
    List: [],
    NumberFromList: [],
    NumberFromObj: "",
    NumberToObj: "",
    column: [],
    selectedData: [],
    isLoading: false,
    columnAll: true
  }

  componentWillMount() {
    const moduleName = this.props.location.state.moduleName
    if (moduleName === "Fabric") {
      this.setState({ isLoading: false })
      this.getFabricNumber("")
    }

    if (moduleName === "Style") {
      StyleServices.SearchStyle("")
        .then(response => {
          if (response.status == 200) {
            let jsonData = []
            response.text.data.map(info =>
              jsonData.push({ label: info.styleNumber, value: info._id })
            )
            this.setState({ NumberFromList: jsonData, isLoading: true })
          }
        })
        .catch(error => {
          // UtilityService.errorMsg(this.msg);
        })
    }

    this.setState({ moduleName })
  }

  componentWillReceiveProps(nextProps) {
    const moduleName = nextProps.location.state.moduleName
    // if (moduleName === "Fabric") {
    //   this.setState({ isLoading: false });
    //   DevelopmentServices.getFabricNumber("")
    //     .then(response => {
    //       if(response.status == 200){
    //         this.setState({ NumberFromList: response.text.data, isLoading: true });
    //       }
    //     })
    //     .catch(error => {
    //       UtilityService.errorMsg(this.msg, error);
    //     });
    // }

    // if (moduleName === "Style") {
    //   this.setState({ isLoading: false });
    //   StyleServices.SearchStyle("")
    //     .then(response => {
    //       if (response.status == 200) {
    //         let jsonData = [];
    //         response.data.map(info => {
    //           let objData = {};
    //           objData.label = info.styleNumber;
    //           objData.value = info._id;
    //           jsonData.push(objData);
    //         });
    //         this.setState({ NumberFromList: jsonData, isLoading: true });
    //       }
    //     })
    //     .catch(error => {
    //       // UtilityService.errorMsg(this.msg);
    //     });
    // }

    this.props.getRights(moduleName)

    this.setState({ moduleName })
  }

  getFabricNumber = value => {
    DevelopmentServices.getFabricNumber(value)
      .then(response => {
        if (response.status == 200) {
          this.setState({ NumberFromList: response.text.data, isLoading: true })
        }
        response.status == 404 &&
          this.props.getalertMessage("error", response.text.message)
        response.status == 401 &&
          this.props.getalertMessage("error", response.text.message)
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  //searchBy
  searchBy = () => {
    let { NumberTo, NumberFrom, SearchDateFrom, SearchDateTo } = this.state
    if (NumberTo !== "" && NumberFrom !== "") {
      let data = {
        filterType: this.state.moduleName === "Fabric" ? "fabricNumber" : "",
        from: NumberFrom,
        to: NumberTo
      }

      if (this.state.moduleName === "Fabric") {
        DevelopmentServices.searchFilterForFabricNumber(data)
          .then(response => {
            this.setState({
              List: response.data
            })
          })
          .catch(error => { })
      }
    }

    if (SearchDateFrom !== "" && SearchDateTo !== "") {
      let data = {
        filterType: "dateRange",
        from: SearchDateFrom,
        to: SearchDateTo
      }
      if (this.state.moduleName === "Fabric") {
        DevelopmentServices.searchFilterForFabricNumber(data)
          .then(response => {
            this.setState({
              List: response.data
            })
          })
          .catch(error => { })
      }
    }
  }

  getNumberList = e => {
    if (this.state.moduleName === "Fabric") {
      if (e != "") {
        DevelopmentServices.getFabricNumber(e)
          .then(response => {
            if (response.status == 200) {
              this.setState({ NumberFromList: response.text.data })
            }
            response.status == 404 &&
              this.props.getalertMessage("error", response.text.message)
            response.status == 401 &&
              this.props.getalertMessage("error", response.text.message)
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
      }
    }
  }

  getNumberFrom = fabricNum => {
    if (fabricNum) {
      this.setState({
        NumberFrom: fabricNum.value,
        NumberFromObj: fabricNum
      })
    } else {
      this.setState({
        NumberFrom: "",
        NumberFromObj: ""
      })
      this.getFabricNumber("")
    }
  }

  getNumberTo = fabricNum => {
    if (fabricNum) {
      this.setState({
        NumberTo: fabricNum.value,
        NumberToObj: fabricNum
      })
    } else {
      this.setState({
        NumberTo: "",
        NumberToObj: ""
      })
      this.getFabricNumber("")
    }
  }

  __handleFromDateChange = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  _handlePageChange = pageNumber => {
    this.setState({ activePage: pageNumber })
  }

  printDiv = val => {
    const divToPrint = document.getElementById(val)
    const newWin = window.open("", "_blank")
  
    newWin.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @media print {
              body { font-family: 'Lato', sans-serif; font-size: 1rem; }
              .print-h-w{height:98%;width:100%;border:1px solid black;page-break-after: always; word-wrap: break-word;}
              .td-border{border-bottom:1px solid black;width:100%;}
              table > tbody > tr td{font-size:11px;vertical-align:top;padding:0px 0px;max-width:100%;}
              .text-center{text-align:center;}
              .f-15{font-size:10px;}
              .qr-wrap{padding:0px;height:100%}
            }
            img {
              display: block;
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
          ${divToPrint.innerHTML}
        </body>
      </html>
    `)
  
    newWin.document.close()
  
    // Wait for images to load before printing
    newWin.onload = () => {
      newWin.focus()
      newWin.print()
      newWin.close()
    }
  }
  

  getRowData = data => {
    let selectedData = []

    if (data.all) {
      selectedData = data.rowData.map((datarowData, index) => {
        let dat = { ...datarowData }
        return dat
      })
    } else {
      selectedData = data.rowData.filter((datarowData, index) => {
        if (datarowData[`checkbox${index}`]) {
          let dat = { ...datarowData }
          return dat
        }
      })
    }

    this.setState({
      all: data.all,
      selectedData,
      column: data.column,
      columnAll: data.columnAll
    })
  }

  render() {
    const {
      List,
      NumberFromObj,
      NumberToObj,
      NumberFromList,
      SearchDateFrom,
      SearchDateTo,
      isLoading,
      selectedData,
      moduleName
    } = this.state

    if (isLoading) {
      return (
        <Fragment>
          <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
          <div className="right-section bg-white">
            <div className="row nopadding">
              <Pageheader
                history={this.props.history}
                header={`Print ${moduleName} Number`}
              />
              <div className="col-md-12 nopadding">
                <div className="card-container">
                  {/*MAIN-CONTENT START*/}
                  {/* FIELDS */}
                  <div class="col-md-12 nopadding">
                    <div class="col-md-6">
                      <h6 className="fw-600">{`Search By ${moduleName} Number`}</h6>
                      {/* FORM GROUP START */}
                      <div className="col-md-6">
                        {/* FROM FIELD START  */}
                        <div className="form-group">
                          <label for="">From</label>
                          <div class="custom-async-select">
                            <Async
                              name="From"
                              value={NumberFromObj}
                              onInputChange={this.getNumberList}
                              onChange={this.getNumberFrom}
                              placeholder={`${moduleName} Number Start`}
                              options={NumberFromList}
                            />
                          </div>
                        </div>
                        {/* FROM FIELD END  */}
                      </div>
                      <div className="col-md-6">
                        {/* TO FIELD START  */}
                        <div className="form-group">
                          <label for="">To</label>
                          <div class="custom-async-select">
                            <Async
                              name="To"
                              value={NumberToObj}
                              onInputChange={e => this.getNumberList(e)}
                              onChange={this.getNumberTo}
                              placeholder={`${moduleName} Number End`}
                              options={NumberFromList}
                            />
                          </div>
                        </div>
                        {/* TO FIELD END  */}
                      </div>
                      {/* FORM GROUP END */}
                    </div>
                    <div class="col-md-6">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="fw-600">Search By Created Date</h6>
                        <div>
                          <span className="btn-green-icon mr-3">
                            <img
                              alt=""
                              className="cursor-pointer"
                              src={printer}
                              onClick={() => this.printDiv("printTable")}
                            />
                          </span>
                          <span className="btn-green-icon ">
                            <img src={download} alt="" />
                          </span>
                        </div>
                      </div>

                      {/* FORM GROUP START */}
                      <div className="col-md-6">
                        {/* FROM FIELD START  */}
                        <div className="form-group">
                          <label for="">From</label>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            inputName="SearchDateFrom"
                            value={SearchDateFrom}
                            onChange={this.__handleFromDateChange}
                          />
                        </div>
                        {/* FROM FIELD END  */}
                      </div>
                      <div className="col-md-6">
                        {/* TO FIELD START  */}
                        <div className="form-group">
                          <label for="">To</label>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            inputName="SearchDateTo"
                            value={SearchDateTo}
                            onChange={this.__handleFromDateChange}
                          />
                        </div>
                        {/* TO FIELD END  */}
                      </div>
                      {/* FORM GROUP END */}
                    </div>
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="primary"
                        onClick={() => this.searchBy()}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                  {/* PRINT FABRIC TABLE */}
                  {List.length > 0 && (
                    <div className="col-md-12 nopadding">
                      <TableRowSelect
                        rowData={List}
                        tableHeaderData={tableHeader.fabricPrintTable}
                        getRowData={this.getRowData}
                      />
                    </div>
                  )}
                </div>
                {/*MAIN-CONTENT END */}
                {/* Print Page */}
                <div id="printTable" className="d-none">
                  {this.state.moduleName === "Fabric" &&
                    selectedData.length > 0 && (
                      <PrintFabricPage
                        tableHeaderData={tableHeader.fabricPrintTable}
                        columnAll={this.state.columnAll}
                        column={this.state.column}
                        selectedData={selectedData}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )
    } else {
      return <Loading />
    }
  }
}

// export default PrintFabricNumber;

const mapStateToProps = state => {
  return {
    rights: state.main.rights,
    selectedRight: state.rights.rightsInfo
  }
}
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getRights: getRights
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintFabricNumber)


// WEBPACK FOOTER //
// ./src/pages/printFabricNumber/page.js